export default __webpack_public_path__ + "static/x-1f5e027afbb5df6829f7890c48199589.png";